import React, {
  useMemo,
  useEffect,
  useRef,
  useCallback,
  useState
} from 'react';


import {
  FormGroup,
  Label,
  Input,
  Button,
  FormText
} from 'reactstrap';

import Select from 'react-select'

import FieldError from '../../../../helper/FieldError';
import SelectEmailNotifications from '../../../../abstract/bulk/request/document_config/select_email_notifications'
import DocumentPreview from '../../../../document/preview'
import BulkRequestDocumentConfigPreviewTemplate from './preview_template';
import DocumentSignerConfigAttributes from '../../../../document/signer_config_attributes';
import SignerFormList from '../../../../signer/form_list';
import {
  analyze as analyzeDocument,
} from '../../../../document/axios';

import {
  inputId,
  inputName,
  drawTooltipHelp,
  tooltipInitializaer
} from '../../../../helper/form';

import {
  onChangeDocumentHelper
} from '../../../../document/helper';

import DocumentSignerConfigContext from '../../../../document/context/signer_config_context'

import {
  drawSignersCoordinatesActionButton,
  requireSignersPosition,
  drawSignerCoordinatesConfigurationModal
} from "../../../../signer/coordinates_configuration/utils";

const BulkRequestDocumentConfigForm = React.memo((props) => {
  const {
    bulkRequestConfig,
    callbackOnChangeConfig,
    index,
    data: {
      documentTypes,
      templates,
      customFieldEmailNotifications,
      allowedFileFormats,
      entitiesSelected,
      shortlistProjects
    },
    configuration: {
      context,
      defaultRequestParams,
      shortlist: shortlistConfiguration
    },
    formName
  } = props;

  const signersObjectRef = useRef({ signers: bulkRequestConfig?.signers || [] })

  const requireSignersPositionValue = useMemo(
    () => requireSignersPosition(bulkRequestConfig),
    [bulkRequestConfig.file, bulkRequestConfig.document_information, bulkRequestConfig.require_signers,  bulkRequestConfig.signers]
  );

  useEffect(() => {
    signersObjectRef.current = { signers: bulkRequestConfig.signers || [] }
  }, [bulkRequestConfig?.signers])

  const documentSignerConfigContextValue = useMemo(() => {
    return {
      resource: {
        require_signers: bulkRequestConfig?.require_signers,
        require_signers_order: bulkRequestConfig?.require_signers_order,
        isPersisted: false,
        certification_mode: bulkRequestConfig?.certification_mode
      },
    }
  }, [
    bulkRequestConfig?.require_signers,
    bulkRequestConfig?.require_signers_order,
    bulkRequestConfig?.certification_mode
  ])

  useEffect(() => {
    tooltipInitializaer()
  }, [bulkRequestConfig])

  useEffect(() => {
    if (bulkRequestConfig.file === null || bulkRequestConfig.file === undefined) return;
    if (bulkRequestConfig.file.type !== 'application/pdf') return;

    let formData = new FormData();
    formData.append(`document[file]`, bulkRequestConfig.file);

    analyzeDocument(formData, response => {
      if (response.status == 200) {
        setBulkRequestConfig(prevConfig => ({
          ...prevConfig,
          certification_mode: response.data.has_signatures ? "per_signer_certification" : "single_certification",
          document_information: response.data
        }));
      } else {
        console.log(response)
      }
    })
  }, [bulkRequestConfig.file])

  const setBulkRequestConfig = (updater) => {
    let newConfig;
    if (typeof updater === 'function') {
      newConfig = updater(bulkRequestConfig);
    } else {
      newConfig = { ...bulkRequestConfig, ...updater };
    }

    if (_.isFunction(callbackOnChangeConfig)) {
      callbackOnChangeConfig(newConfig, index);
    }
  };

  const [modalSignerCoordinates, setModalSignerCoordinates] = useState(false);

  const toggleModalSignerCoordinate = () => setModalSignerCoordinates(!modalSignerCoordinates);

  const requireSignersPositionModalRef = useRef({})

  const shortlistProjectById = useCallback((id) => {
    return _.find(shortlistProjects, { id: id })
  })

  const handleConfigData = (event, key) => {
    let value = event.target.value;
    const type = event.target.type;

    let _bulkRequestConfig = { ...bulkRequestConfig };

    if (type == 'checkbox') {
      value = event.target.checked;
    }

    if (type == 'file') {
      value = event.target.files[0]
    }

    _bulkRequestConfig = {
      ...bulkRequestConfig,
      ...onChangeDocumentHelper(_bulkRequestConfig, key, value, documentTypes)
    }

    _bulkRequestConfig[key] = value;

    if (key == 'shortlist_project_id') {
      _bulkRequestConfig['shortlist_project_name'] = shortlistProjectById(value)?.title;
    }


    if (_.isFunction(callbackOnChangeConfig)) {
      callbackOnChangeConfig(_bulkRequestConfig, index)
    }
  }

  // ---------- START DOCUMENT TYPE ----------
  const documentTypeSelectInput = () => {
    return (
      <FormGroup>
        <FieldError errors={bulkRequestConfig?.errors?.document_type_id || []}>
          <Label
            for={inputId(formName, 'document_type_id')}
            className="required"
          >
            {I18n.t('activerecord.attributes.document.document_type_id')}
          </Label>

          <Select
            id={inputId(formName, 'document_type_id')}
            name={inputName(formName, 'document_type_id')}
            invalid={_.has(bulkRequestConfig?.errors, 'document_type_id')}
            value={documentTypeSelectedOption}
            onChange={e => handleConfigData({ target: { value: e?.value } }, "document_type_id")}
            options={documentTypeSelectOptions}
            isClearable={true}
            placeholder={`-- Selecciona un ${I18n.t('activerecord.attributes.document.document_type_id')} --`}
          />
        </FieldError>
      </FormGroup>
    )
  }

  const documentTypeSelectedOption = useMemo(() => {
    let selected = _.find(documentTypes, { id: bulkRequestConfig?.document_type_id })

    if (selected) {
      return { value: selected.id, label: selected.name }
    } else {
      return null
    }
  }, [bulkRequestConfig?.document_type_id])

  const documentTypeSelectOptions = useMemo(() => {
    return _.map(documentTypes, function (document_type) {
      return { value: document_type.id, label: document_type.name }
    })
  }, [])
  // ---------- END DOCUMENT TYPE ----------

  // ---------- START LABEL ----------
  const labelInput = () => {
    return (
      <FormGroup>
        <FieldError errors={bulkRequestConfig?.label?.errors || []}>
          <Label
            for={inputId(formName, 'label')}
          >
            {I18n.t('activerecord.attributes.document.label')}
          </Label>

          {drawTooltipHelp(I18n.t('documents.form.label_tooltip'))}

          <Input
            type='text'
            id={inputId(formName, 'label')}
            name={inputName(formName, 'label')}
            invalid={_.has(bulkRequestConfig?.errors, 'label')}
            value={bulkRequestConfig?.label || ''}
            onChange={e => handleConfigData(e, "label")}
          />
        </FieldError>
      </FormGroup>
    )
  }
  // ---------- END LABEL ----------

  // ---------- START UPLOADED BY ----------

  const uploadByEmployee = () => {
    if (context == 'laboral_bulk') {
      return (
        <div className="form-check">
          <Input
            type='radio'
            className='form-check-input'
            name={inputName(formName, 'uploaded_by')}
            id={inputId(formName, 'uploaded_by_upload_file_employee')}
            value={'upload_file_employee'}
            checked={bulkRequestConfig?.uploaded_by == 'upload_file_employee'}
            onChange={e => handleConfigData(e, 'uploaded_by')}
            invalid={_.has(bulkRequestConfig?.errors, 'uploaded_by')}
          />
          <Label
            className='form-check-label d-block'
            for={inputId(formName, 'uploaded_by_upload_file_employee')}
          >
            <i className="fas fa-file-import fa-lg mr-2 text-muted"></i>
            {I18n.t('activerecord.attributes.laboral/bulk/request/hiring_document_config.uploaded_by.upload_file_employee')}
          </Label>
        </div>
      )
    }
  }

  const uploadByAbstractRepresentative = () => {
    if (context == 'abstract_bulk') {
      return (
        <div className="form-check">
          <Input
            type='radio'
            className='form-check-input'
            name={inputName(formName, 'uploaded_by')}
            id={inputId(formName, 'uploaded_by_upload_file_employee')}
            value={'upload_file_employee'}
            checked={bulkRequestConfig?.uploaded_by == 'upload_file_employee'}
            onChange={e => handleConfigData(e, 'uploaded_by')}
            invalid={_.has(bulkRequestConfig?.errors, 'uploaded_by')}
          />
          <Label
            className='form-check-label'
            for={inputId(formName, 'uploaded_by_upload_file_employee')}
          >
            <i className="fas fa-file-import fa-lg mr-2 text-muted"></i>
            {I18n.t('activerecord.attributes.abstract/bulk/request/document_config.uploaded_by.upload_file_employee')}
          </Label>

          {function () {
            if (context == 'abstract_bulk' && bulkRequestConfig.uploaded_by == 'upload_file_employee') {
              return (
                <div className="mt-3">
                  {emailNotificationSelect()}
                </div>
              )
            }
          }()}
        </div>
      )
    }
  }

  const uploadByClient = () => {
    if (context == 'corporate_bulk') {
      return (
        <div className="form-check">
          <Input
            type='radio'
            className='form-check-input'
            name={inputName(formName, 'uploaded_by')}
            id={inputId(formName, 'uploaded_by_upload_file_client')}
            value={'upload_file_client'}
            checked={bulkRequestConfig?.uploaded_by == 'upload_file_client'}
            onChange={e => handleConfigData(e, 'uploaded_by')}
            invalid={_.has(bulkRequestConfig?.errors, 'uploaded_by')}
          />
          <Label
            className='form-check-label'
            for={inputId(formName, 'uploaded_by_upload_file_client')}
          >
            <i className="fas fa-file-upload fa-lg mr-2 text-muted"></i>
            {I18n.t('activerecord.attributes.corporate/bulk/request/agreement_document_config.uploaded_by.upload_file_client')}
          </Label>
        </div>
      )
    }
  }

  const uploadByProvider = () => {
    if (context == 'corporate_bulk') {
      return (
        <div className="form-check">
          <Input
            type='radio'
            className='form-check-input'
            name={inputName(formName, 'uploaded_by')}
            id={inputId(formName, 'uploaded_by_upload_file_provider')}
            value={'upload_file_provider'}
            checked={bulkRequestConfig?.uploaded_by == 'upload_file_provider'}
            onChange={e => handleConfigData(e, 'uploaded_by')}
            invalid={_.has(bulkRequestConfig?.errors, 'uploaded_by')}
          />
          <Label
            className='form-check-label'
            for={inputId(formName, 'uploaded_by_upload_file_provider')}
          >
            <i className="fas fa-file-upload fa-lg mr-2 text-muted"></i>
            {I18n.t('activerecord.attributes.corporate/bulk/request/agreement_document_config.uploaded_by.upload_file_provider')}
          </Label>
        </div>
      )
    }
  }

  const uploadedByInput = () => {
    return (
      <FormGroup>
        <div className="fw-bold mb-2">
          {I18n.t(`activerecord.attributes.laboral/bulk/request/hiring_document_config.file`)}
        </div>
        <FieldError errors={bulkRequestConfig?.uploaded_by?.errors || []}>
          <div className="card mb-1">
            <div className="card-header options-card bg-real-light">
              <div className="form-check">
                <Input
                  type='radio'
                  className='form-check-input'
                  name={inputName(formName, 'uploaded_by')}
                  id={inputId(formName, 'uploaded_by_upload_file_user')}
                  value={'upload_file_user'}
                  checked={bulkRequestConfig?.uploaded_by == 'upload_file_user'}
                  onChange={e => handleConfigData(e, 'uploaded_by')}
                  invalid={_.has(bulkRequestConfig?.errors, 'uploaded_by')}
                />
                <Label
                  className='form-check-label d-block'
                  for={inputId(formName, 'uploaded_by_upload_file_user')}
                >
                  <i className="fas fa-upload fa-lg mr-2 text-muted"></i>
                  {I18n.t('activerecord.attributes.laboral/bulk/request/hiring_document_config.uploaded_by.upload_file_user')}
                </Label>
              </div>
            </div>
            {bulkRequestConfig.uploaded_by == 'upload_file_user' &&
              <React.Fragment>
                <div className="card-body">
                  {fileInput()}
                  {keepFormatSwitchInput()}
                </div>
              </React.Fragment>
            }
          </div>
          <div className="card mb-1">
            <div className="card-header options-card bg-real-light">
              {uploadByEmployee()}
              {uploadByAbstractRepresentative()}
              {uploadByClient()}
              {uploadByProvider()}
            </div>
            {bulkRequestConfig.uploaded_by == 'upload_file_employee' &&
              <React.Fragment>
                <div className="card-body">
                  {requireUploadDeadlineSwitchInput()}
                  {uploadDeadlineAtInput()}
                  {keepFormatSwitchInput()}
                </div>
              </React.Fragment>
            }
            {function () {
              if (bulkRequestConfig.uploaded_by == 'upload_file_provider' || bulkRequestConfig.uploaded_by == 'upload_file_client') {
                return (
                  <React.Fragment>
                    <div className="card-body">
                      {keepFormatSwitchInput()}
                    </div>
                  </React.Fragment>
                )
              }
            }()}
          </div>
          <div className="card mb-1">
            <div className="card-header options-card bg-real-light">
              <div className="form-check">
                <Input
                  type='radio'
                  className='form-check-input'
                  name={inputName(formName, 'uploaded_by')}
                  id={inputId(formName, 'template')}
                  value={'controldoc_form_template'}
                  checked={bulkRequestConfig?.uploaded_by == 'controldoc_form_template'}
                  onChange={e => handleConfigData(e, 'uploaded_by')}
                  invalid={_.has(bulkRequestConfig?.errors, 'uploaded_by')}
                />
                <Label
                  className='form-check-label d-block'
                  for={inputId(formName, 'template')}
                >
                  <i className="fas fa-paste fa-lg mr-2 text-muted"></i>
                  {I18n.t('activerecord.attributes.laboral/bulk/request/hiring_document_config.uploaded_by.upload_controldoc_form')}

                </Label>
              </div>
            </div>
            {bulkRequestConfig?.uploaded_by == 'controldoc_form_template' &&
              <React.Fragment>
                <div className="card-body">
                  {completedByInput()}
                  {controldocFormTemplateSelectInput()}
                  {previewTemplate()}
                </div>
              </React.Fragment>
            }
          </div>

          {uploadedByShortlistProject()}
        </FieldError>
      </FormGroup>
    )
  }
  // ---------- END UPLOADED BY ----------


  // ---------- START SHORTLIST PROJECT ----------
  const enabledShorlistProject = useMemo(() => {
    return shortlistConfiguration?.enabled && context == 'laboral_bulk'
  }, [shortlistConfiguration, context])

  const uploadedByShortlistProject = () => {
    if (enabledShorlistProject) {
      return (
        <div className="card mb-1">
          <div className="card-header options-card bg-real-light">
            <div className="form-check">
              <Input
                type='radio'
                className='form-check-input'
                name={inputName(formName, 'uploaded_by')}
                id={inputId(formName, 'shortlist_project')}
                value={'shortlist_project'}
                checked={bulkRequestConfig?.uploaded_by == 'shortlist_project'}
                onChange={e => handleConfigData(e, 'uploaded_by')}
                invalid={_.has(bulkRequestConfig?.errors, 'uploaded_by')}
              />
              <Label
                className='form-check-label d-block'
                for={inputId(formName, 'shortlist_project')}
              >
                <i className="far fa-comment-alt fa-lg mr-2 text-muted"></i>
                {I18n.t('activerecord.attributes.laboral/bulk/request/hiring_document_config.uploaded_by.upload_shortlist_project')}

              </Label>
            </div>
          </div>
          {bulkRequestConfig?.uploaded_by == 'shortlist_project' &&
            <React.Fragment>
              <div className="card-body">
                {shortlistProjectSelectInput()}
              </div>
            </React.Fragment>
          }
        </div>
      )
    }
  }

  const shortlistProjectSelectOptions = useMemo(() => {
    const _shortlistProjects = _.sortBy(shortlistProjects, 'title')

    return _.map(_shortlistProjects, shortlistProject => {
      return { value: shortlistProject.id, label: shortlistProject.title }
    })
  }, [shortlistProjects])

  const shortlistProjectSelectedOption = useMemo(() => {
    const options = shortlistProjectSelectOptions;

    return _.find(options, { value: bulkRequestConfig?.shortlist_project_id }) || null

  }, [bulkRequestConfig?.shortlist_project_id])

  const shortlistProjectSelectInput = () => {
    return (
      <FormGroup>
        <FieldError errors={bulkRequestConfig?.errors?.shortlist_project_id || []}>
          <Label
            for={inputId(formName, 'shortlist_project_id')}
            className="required"
          >
            {I18n.t('activerecord.attributes.laboral/bulk/request/hiring_document_config.shortlist_project_id')}
          </Label>

          <Select
            id={inputId(formName, 'shortlist_project_id')}
            name={inputName(formName, 'shortlist_project_id')}
            options={shortlistProjectSelectOptions}
            value={shortlistProjectSelectedOption}
            onChange={e => handleConfigData({ target: { value: e?.value } }, "shortlist_project_id")}
            isClearable={true}
            placeholder={'-- Selecciona un proyecto de Shortlist --'}
            invalid={_.has(bulkRequestConfig?.errors, 'shortlist_project_id')}
          />
        </FieldError>
      </FormGroup>
    )
  }

  // ---------- START SHORTLIST PROJECT ----------

  // ---------- START AUTOCOMPLETED BY ENTITY ----------
  const completedByInput = () => {
    if (bulkRequestConfig?.uploaded_by == 'controldoc_form_template') {
      return (
        <>
          <FormGroup className='ml-3'>
            <FieldError errors={bulkRequestConfig?.completed_by?.errors || []}>
              <div className="form-check">
                <Input
                  type='radio'
                  className='form-check-input'
                  name={inputName(formName, 'completed_by_entity')}
                  id={inputId(formName, 'completed_by_entity')}
                  value={"entity"}
                  checked={bulkRequestConfig?.completed_by == "entity"}
                  onChange={e => handleConfigData(e, 'completed_by')}
                />
                <Label
                  className='form-check-label lh-sm'
                  for={inputId(formName, 'completed_by_entity')}
                >
                  {I18n.t('activerecord.attributes.laboral/bulk/request/hiring_document_config.completed_by_entity')}
                  <small className="form-text m-0">{I18n.t('activerecord.attributes.laboral/bulk/request/hiring_document_config.completed_by_entity_help')}</small>
                </Label>
              </div>

              <div className="form-check">
                <Input
                  type='radio'
                  className='form-check-input'
                  name={inputName(formName, 'completed_by_system')}
                  id={inputId(formName, 'completed_by_system')}
                  value={"system"}
                  checked={bulkRequestConfig?.completed_by == "system"}
                  onChange={e => handleConfigData(e, 'completed_by')}
                />
                <Label
                  className='form-check-label lh-sm'
                  for={inputId(formName, 'completed_by_system')}
                >
                  {I18n.t('activerecord.attributes.laboral/bulk/request/hiring_document_config.completed_by_system')}
                  <small className="form-text m-0">{I18n.t('activerecord.attributes.laboral/bulk/request/hiring_document_config.completed_by_system_help')}</small>
                </Label>
              </div>

              <div className="form-check">
                <Input
                  type='radio'
                  className='form-check-input'
                  name={inputName(formName, 'completed_by_third_party')}
                  id={inputId(formName, 'completed_by_third_party')}
                  value={"third_party"}
                  checked={bulkRequestConfig?.completed_by == "third_party"}
                  onChange={e => handleConfigData(e, 'completed_by')}
                />
                <Label
                  className='form-check-label lh-sm'
                  for={inputId(formName, 'completed_by_true')}
                >
                  {I18n.t('activerecord.attributes.laboral/bulk/request/hiring_document_config.completed_by_third_party')}
                  <small className="form-text m-0">{I18n.t('activerecord.attributes.laboral/bulk/request/hiring_document_config.completed_by_third_party_help')}</small>
                </Label>
              </div>
            </FieldError>
          </FormGroup>
          {function () {
            if (bulkRequestConfig.uploaded_by == 'controldoc_form_template' && bulkRequestConfig.completed_by == "third_party") {
              return (
                <div className="mt-3">
                  {thirdPartyEmailInput()}
                </div>
              )
            } else if (context == 'abstract_bulk' && bulkRequestConfig.uploaded_by == 'controldoc_form_template') {
              return (
                <div className="mt-3">
                  {emailNotificationSelect()}
                </div>
              )
            } else if (context == 'corporate_bulk' && bulkRequestConfig.uploaded_by == 'controldoc_form_template') {
              return (
                <div className="mt-3">
                  {requestedToSelectInput()}
                </div>
              )
            }
          }()}
        </>
      )
    }
  }
  // ---------- END AUTOCOMPLETED BY ENTITY ----------

  // ---------- START TEMPLATE ----------
  const controldocFormTemplateSelectInput = () => {
    if (bulkRequestConfig.uploaded_by == 'controldoc_form_template') {
      return (
        <FormGroup>
          <FieldError errors={bulkRequestConfig?.errors?.template || []}>
            <Label
              for={inputId(formName, 'template_id')}
              className="required"
            >
              {I18n.t('activerecord.attributes.laboral/bulk/request/hiring_document_config.templates')}
            </Label>

            <Select
              id={inputId(formName, 'template_id')}
              name={inputName(formName, 'template_id')}
              value={templateSelectedOption}
              onChange={e => handleConfigData({ target: { value: e?.value } }, "template_id")}
              options={templateSelectOptions}
              isClearable={true}
              placeholder={'-- Selecciona una plantilla --'}
              invalid={_.has(bulkRequestConfig?.errors, 'template')}
              maxMenuHeight={150}
            />
          </FieldError>
        </FormGroup>
      )
    }
  }

  const templateSelectedOption = useMemo(() => {
    const selected = _.find(templates, { id: bulkRequestConfig?.template_id });

    if (selected) {
      return { label: selected?.name, value: selected?.id }
    } else {
      return null
    }
  }, [bulkRequestConfig?.template_id])

  const templateSelectOptions = useMemo(() => {
    return _.map(templates, template => ({ value: template.id, label: template.name }))
  }, [templates])
  // ---------- END TEMPLATE ----------

  // ---------- START REQUESTED_TO (OnlyCorporate) ----------
  const requestedToSelectInput = () => {
    if (context == 'corporate_bulk') {
      return (
        <div className="row">
          <div className="col-xs-12">
            <FormGroup>
              <Input
                type='select'
                value={bulkRequestConfig?.requested_to || ""}
                onChange={e => handleConfigData(e, 'requested_to')}
                invalid={_.has(bulkRequestConfig?.errors, 'requested_to')}
              >
                <option
                  value={""}
                  key={_.uniqueId(`request-to-option-`)}
                >
                  {"Selecciona un representante"}
                </option>
                <option
                  value={"legal_representative_client"}
                  key={"request-to-option-client"}
                >
                  {I18n.t('activerecord.attributes.corporate/bulk/request/agreement_document_config.requested_to.legal_representative_client')}
                </option>
                <option
                  value={"legal_representative_provider"}
                  key={"request-to-option-provider"}
                >
                  {I18n.t('activerecord.attributes.corporate/bulk/request/agreement_document_config.requested_to.legal_representative_provider')}
                </option>
              </Input>
            </FormGroup>
          </div>
        </div>
      )
    }
  }

  // ---------- END REQUESTED_TO (OnlyCorporate)----------

  // ---------- START SELECT EMAIL NOTIFICATION (OnlyAbstract) ----------
  const emailNotificationSelect = () => {
    if (context == 'abstract_bulk') {
      return (
        <SelectEmailNotifications
          value={bulkRequestConfig.custom_field_id}
          handleConfigData={handleConfigData}
          customFieldEmailNotifications={customFieldEmailNotifications}
          errors={bulkRequestConfig.errors || {}}
        />
      )
    }
  }
  // ---------- END SELECT EMAIL NOTIFICATION (OnlyAbstract) ----------

  const previewTemplate = () => {
    if (bulkRequestConfig.uploaded_by == 'controldoc_form_template' && bulkRequestConfig.template_id && entitiesSelected.length > 0) {
      return (
        <BulkRequestDocumentConfigPreviewTemplate
          entitiesSelected={entitiesSelected}
          data={props?.data}
          bulkRequestConfig={bulkRequestConfig}
          configuration={{
            context: context,
            defaultRequestParams: defaultRequestParams
          }}
        />
      )
    }
  }

  const thirdPartyEmailInput = () => {
    if (bulkRequestConfig.uploaded_by == 'controldoc_form_template' && bulkRequestConfig.completed_by == 'third_party') {
      return (
        <FormGroup>
          <FieldError errors={bulkRequestConfig?.errors?.third_party_email || []}>
            <Label
              for={inputId(formName, 'third_party_email')}
              className="required"
            >
              {I18n.t('activerecord.attributes.laboral/bulk/request/hiring_document_config.third_party_email')}
            </Label>
            <Input
              type='email'
              id={inputId(formName, `third_party_email`)}
              name={inputName(formName, 'third_party_email')}
              onChange={e => handleConfigData(e, 'third_party_email')}
              invalid={_.has(bulkRequestConfig?.errors, 'third_party_email')}
            />
          </FieldError>
        </FormGroup>
      )
    }
  }


  // ---------- START FILE ----------
  const fileInput = () => {
    if (bulkRequestConfig.uploaded_by == 'upload_file_user') {
      return (
        <FormGroup>
          <FieldError errors={bulkRequestConfig?.errors?.file || []}>
            <Label
              for={inputId(formName, 'file')}
              className="required"
            >
              {I18n.t(`activerecord.attributes.abstract/bulk/request/document_config.file`)}
            </Label>

            <Input
              type='file'
              id={inputId(formName, `file`)}
              name={inputName(formName, 'file')}
              onChange={e => handleConfigData(e, 'file')}
              invalid={_.has(bulkRequestConfig?.errors, 'file')}
              accept={_.map(allowedFileFormats, 'content_type')}
            />

            <DocumentPreview
              file={bulkRequestConfig?.file}
              allowedContentTypes={_.map(allowedFileFormats, 'content_type')}
            />
          </FieldError>
        </FormGroup>
      )
    }
  }
  // ---------- END FILE ----------

  // ---------- START KEEP FORMAT ----------
  const keepFormatSwitchInput = () => {
    if (bulkRequestConfig?.uploaded_by !== 'controldoc_form_template') {
      return (
        <FormGroup>
          <FieldError errors={bulkRequestConfig?.errors?.keep_format || []}>
            <div className='custom-switch'>
              <Input
                className='custom-control-input'
                type='checkbox'
                name={inputName(formName, 'keep_format')}
                id={inputId(formName, 'keep_format')}
                invalid={_.has(bulkRequestConfig?.errors, 'keep_format')}
                onChange={e => handleConfigData(e, 'keep_format')}
                checked={bulkRequestConfig?.keep_format || false}
                disabled={bulkRequestConfig?.require_signers}
              />
              <Label
                className='custom-control-label'
                for={inputId(formName, 'keep_format')}
              >
                {I18n.t(`activerecord.attributes.document.keep_format`)}
                {drawTooltipHelp(I18n.t('documents.new.keep_format_help'))}
              </Label>
              {bulkRequestConfig.require_signers &&
                <FormText color="info" className="mt-0 lh-sm">
                  <i className="fas fa-info mr-2"></i>
                  Solo disponible en documentos sin firmantes
                </FormText>
              }
            </div>
          </FieldError>
        </FormGroup>
      )
    }
  }
  // ---------- END KEEP FORMAT ----------

  // ---------- START REQUIREUPLOADDEADLINE ----------
  const requireUploadDeadlineSwitchInput = () => {
    if (bulkRequestConfig?.uploaded_by == 'upload_file_employee') {
      return (
        <FormGroup>
          <FieldError errors={bulkRequestConfig?.errors?.require_upload_deadline || []}>
            <div className='custom-switch'>
              <Input
                className='custom-control-input'
                type='checkbox'
                name={inputName(formName, 'require_upload_deadline')}
                id={inputId(formName, 'require_upload_deadline')}
                invalid={_.has(bulkRequestConfig?.errors, 'require_upload_deadline')}
                onChange={e => handleConfigData(e, 'require_upload_deadline')}
                checked={bulkRequestConfig?.require_upload_deadline || false}
              />
              <Label
                className='custom-control-label'
                for={inputId(formName, 'require_upload_deadline')}
              >
                {I18n.t(`activerecord.attributes.abstract/bulk/request/document_config.require_upload_deadline`)}
                {drawTooltipHelp(I18n.t('abstract.bulk.request.document_configs.require_upload_deadline_help'))}
              </Label>
            </div>
          </FieldError>
        </FormGroup>
      )
    }
  }

  const uploadDeadlineAtInput = () => {
    if (bulkRequestConfig?.require_upload_deadline) {
      return (
        <FormGroup>
          <FieldError errors={bulkRequestConfig?.errors?.upload_deadline_at}>
            <Input
              type='datetime-local'
              id={inputId(formName, 'upload_deadline_at')}
              name={inputName(formName, 'upload_deadline_at')}
              invalid={_.has(bulkRequestConfig?.errors, 'upload_deadline_at')}
              onChange={e => handleConfigData(e, 'upload_deadline_at')}
              value={bulkRequestConfig?.upload_deadline_at ? moment(bulkRequestConfig.upload_deadline_at).format('YYYY-MM-DD HH:mm') : ''}
            />
          </FieldError>
        </FormGroup>
      )
    }
  }
  // ---------- START REQUIREUPLOADDEADLINE ----------


  // ---------- START REQUIRES EXPIRE ----------
  const requiresExpireSwitchInput = () => {
    return (
      <FormGroup>
        <FieldError errors={bulkRequestConfig?.errors?.requires_expire || []}>
          <div className='custom-switch'>
            <Input
              className='custom-control-input'
              type='checkbox'
              name={inputName(formName, 'requires_expire')}
              id={inputId(formName, 'requires_expire')}
              invalid={_.has(bulkRequestConfig?.errors, 'requires_expire')}
              onChange={e => handleConfigData(e, 'requires_expire')}
              checked={bulkRequestConfig?.requires_expire || false}
            />
            <Label
              className='custom-control-label'
              for={inputId(formName, 'requires_expire')}
            >
              {I18n.t(`activerecord.attributes.laboral/bulk/request/hiring_document_config.requires_expire`)}
            </Label>
          </div>
        </FieldError>
      </FormGroup>
    )
  }

  const expiresAtInput = () => {
    if (bulkRequestConfig?.requires_expire) {
      return (
        <FormGroup>
          <FieldError errors={bulkRequestConfig?.errors?.expires_at || []}>
            <Label
              for={inputId(formName, 'expires_at')}
              className="required"
            >
              {I18n.t(`activerecord.attributes.laboral/bulk/request/hiring_document_config.expires_at`)}
            </Label>
            <Input
              type='date'
              id={inputId(formName, 'expires_at')}
              name={inputName(formName, 'expires_at')}
              invalid={_.has(bulkRequestConfig?.errors, 'expires_at')}
              onChange={e => handleConfigData(e, 'expires_at')}
              value={bulkRequestConfig?.expires_at || ''}
            />
          </FieldError>
        </FormGroup>
      )
    }
  }
  // ---------- END REQUIRES EXPIRE ----------

  // ---------- START SIGNERS ----------
  const signerFormList = () => {
    if (bulkRequestConfig.require_signers) {
      return (
        <div className="card card-outline card-primary">
          <div className="card-header">
            {I18n.t('activerecord.models.signer.other')}
            <div class="card-tools">
              {drawSignersCoordinatesActionButton({
                requireSignersPositionValue,
                toggleModalSignerCoordinate,
              })}
            </div>
          </div>
          <div className="card-body">
            <SignerFormList
              signers={bulkRequestConfig?.signers || []}
              formName={`${formName}[signer_attributes]`}
              setResource={onHandleSigner}
              signersErrors={bulkRequestConfig?.errors?.signers || []}
            />
          </div>
        </div>
      )
    }
  }

  const onHandleSigner = (_function) => {
    const object = _function(signersObjectRef.current)

    signersObjectRef.current = object;

    if (_.isFunction(callbackOnChangeConfig)) {
      let current= { signers: signersObjectRef.current.signers };
      let hasAdvance = _.some(signersObjectRef.current.signers, { signature_mode: "advance" });

      if (hasAdvance) {
        current.require_signers_order = true;
        current.certification_mode = "per_signer_certification"
      } else {
        current.certification_mode = "single_certification"
      }

      callbackOnChangeConfig(
        current,
        index
      )
    }
  }
  // ---------- END SIGNERS ----------

  // ---------- START DELETE BUTTON ----------
  const deleteButton = () => {
    return (
      <FormGroup className='text-end'>
        <Button
          color='danger'
          size='sm'
          onClick={e => onConfirmDestroyConfig()}
          outline
        >
          <i className="fas fa-file-excel mr-1"></i> {I18n.t('laboral.bulk.request.hiring_documents.form.remove_config')}
        </Button>
      </FormGroup>
    )
  }

  const onConfirmDestroyConfig = () => {
    swalWithBootstrap.fire({
      title: 'Eliminar solicitud de documento',
      html: '¿Estás seguro de eliminar el documento?',
    }).then(result => {
      if (result.isConfirmed) {
        onDestroyConfig()
      }
    })
  }

  const onDestroyConfig = () => {
    bulkRequestConfig._destroy = true

    if (_.isFunction(callbackOnChangeConfig)) {
      callbackOnChangeConfig(bulkRequestConfig, index);
    }
  }

  // ---------- END DELETE BUTTON ----------
  return (
    <DocumentSignerConfigContext.Provider value={documentSignerConfigContextValue}>
      <div className={`row ${bulkRequestConfig._destroy ? 'd-none' : ''}`}>
        <div className="col-12">
          <div className="card accordion-item overflow-hidden mb-2">
            <div className="accordion-header fw-bold" id={`headingToggler-${index}`}>
              <button
                className="accordion-button collapsed text-muted text-center"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapseToggler-${index}`}
                aria-expanded="true"
                aria-controls={`collapseToggler-${index}`}
              >
                <div className="row w-100">
                  <div className="col-md-12 text-left fw-bold">
                    <i className="fas fa-file-alt mr-2"></i>
                    {I18n.t('activerecord.models.document.one')}{" "}
                    {bulkRequestConfig.label}
                  </div>
                </div>
              </button>
            </div>
            <div id={`collapseToggler-${index}`}
              className="card-body accordion-body accordion-collapse collapse show"
              aria-labelledby={`headingToggler-${index}`}
              data-bs-parent="#accordionDocs">
              {documentTypeSelectInput()}
              {labelInput()}

              {uploadedByInput()}

              <hr className="my-4"/>

              <span className="fw-bold">
                { I18n.t('activerecord.attributes.laboral/bulk/request/hiring_document_config.expires_at_label') }
                {drawTooltipHelp(I18n.t('activerecord.attributes.laboral/bulk/request/hiring_document_config.expires_at_help'))}
              </span>

              {requiresExpireSwitchInput()}
              {expiresAtInput()}

              <span className="fw-bold">
                {I18n.t('activerecord.models.signer.other')}
              </span>

              <DocumentSignerConfigAttributes
                handleResource={handleConfigData}
                resource={bulkRequestConfig}
                formName={formName}
              />

              {signerFormList()}

              {deleteButton()}
            </div>
          </div>
        </div>
      </div>
      {
        drawSignerCoordinatesConfigurationModal({
          requireSignersPositionModalRef,
          requireSignersPositionValue,
          modalSignerCoordinates,
          toggleModalSignerCoordinate,
          resource: bulkRequestConfig,
          setResource: setBulkRequestConfig
        })
      }
    </DocumentSignerConfigContext.Provider>
  )
})

export default BulkRequestDocumentConfigForm;
